import React from 'react';
import { Link } from 'react-router-dom';
import TypingEffect from '../../../components/TypingEffect';

function HeroSection({ yearsOfExperience }) {
  const codeContentHtml = `<span class="text-[#569cd6]">package</span> <span class="text-[#4ec9b0]">in.rishabh_gupta.controllers</span>;

<span class="text-[#569cd6]">import</span> <span class="text-[#4ec9b0]">org.springframework.web.bind.annotation.*</span>;
<span class="text-[#569cd6]">import</span> <span class="text-[#4ec9b0]">in.rishabh_gupta.service.UserService</span>;

<span class="text-[#608b4e]">@RestController</span>
<span class="text-[#608b4e]">@RequestMapping</span>(<span class="text-[#ce9178]">"/api/users"</span>)

<span class="text-[#569cd6]">public class</span> <span class="text-[#4ec9b0]">UserController</span> {
  <span class="text-[#569cd6]">private final</span> <span class="text-[#4ec9b0]">UserService</span> userService;
  <span class="text-[#569cd6]">public</span> <span class="text-[#4ec9b0]">UserController</span>(<span class="text-[#4ec9b0]">UserService</span> userService) {
    <span class="text-[#569cd6]">this</span>.userService = userService;
  }
  
  <span class="text-[#608b4e]">@GetMapping</span>(<span class="text-[#ce9178]">"/{id}"</span>)
  <span class="text-[#569cd6]">public</span> <span class="text-[#4ec9b0]">User</span> <span class="text-[#dcdcaa]">show</span>(<span class="text-[#608b4e]">@PathVariable</span> <span class="text-[#569cd6]">Long</span> id) {
    <span class="text-[#569cd6]">return</span> <span class="text-[#569cd6]">this</span>.userService.<span class="text-[#dcdcaa]">show</span>(id);
  }
  
  <span class="text-[#608b4e]">@PostMapping</span>
  <span class="text-[#569cd6]">public</span> <span class="text-[#4ec9b0]">User</span> <span class="text-[#dcdcaa]">store</span>(<span class="text-[#608b4e]">@RequestBody</span> <span class="text-[#4ec9b0]">User</span> user) {
    <span class="text-[#569cd6]">return</span> <span class="text-[#569cd6]">this</span>.userService.<span class="text-[#dcdcaa]">store</span>(user);
  }
}`;
  return (
    <section className="relative flex items-center min-h-[80vh] py-32 overflow-hidden bg-bg-dark">
      <div className="max-w-6xl mx-auto px-5 flex flex-wrap items-center justify-between gap-12">
        <div className="flex-1 min-w-[300px] text-left">
          <span className="inline-block bg-white/8 text-text-gray px-4 py-2 rounded-full text-sm uppercase tracking-wider mb-5">
            [RISHABH GUPTA / SOFTWARE ENGINEER]
          </span>
          <h1 className="text-5xl lg:text-6xl text-text-white font-bold leading-tight my-5">
            Building Scalable <span className="text-accent-red">Digital Solutions.</span> Robust Web Systems for Growing Teams.
          </h1>
          <p className="text-lg text-text-gray max-w-xl my-5 mb-10">
            As a Senior Software Engineer with over {yearsOfExperience} years of experience, I specialize in Java-based backend development, focusing on designing and deploying high-performance, enterprise-grade solutions.
          </p>
          <div className="flex gap-4">
            <Link to="/contact" className="bg-accent-red text-text-white rounded-full px-6 py-3 font-bold transition-all duration-300 hover:bg-red-700 hover:-translate-y-0.5">
              Hire Me
            </Link>
          </div>
        </div>
        <div className="flex-1 min-w-[400px] relative h-[400px] flex items-center justify-center">
          <div className="bg-[#1e1e1e] rounded-lg shadow-2xl w-full max-w-xl h-full border border-border-subtle flex flex-col">
            <div className="bg-[#333] px-4 py-2.5 flex items-center border-b border-[#444]">
              <span className="w-3 h-3 rounded-full bg-[#ff5f56] mr-2"></span>
              <span className="w-3 h-3 rounded-full bg-[#ffbd2e] mr-2"></span>
              <span className="w-3 h-3 rounded-full bg-[#27c93f] mr-2"></span>
              <span className="text-[#ccc] text-sm ml-2.5">UserController.java</span>
            </div>
            <pre className="flex-grow p-4 overflow-y-auto font-mono leading-relaxed text-[#d4d4d4] whitespace-pre-wrap">
              <code className="language-java break-all">
                <TypingEffect htmlContent={codeContentHtml} speed={50} delay={1000} />
              </code>
            </pre>
          </div>
        </div>
      </div>
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex space-x-2">
      </div>
    </section>
  );
}

export default HeroSection;